import restaurantModalLoginInstance from '../../../modalLoginInstance'
import restaurantInstance from '../../../instance'

const abortTableOrders = (tableId, data, hasModalLogin = true) => {
	return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
		.post(`/tables/${tableId}/orders/abort`, data)
}

export default abortTableOrders
